import '../estilo/streamings.scss'
import * as comun from './modulos/comun'
import * as buscador from './widgets/buscador'
import { getFechaMesCorto } from './modulos/utiles'
import articulus from './modulos/articulus'

comun.registrarServiceWorker().catch(error => { console.error(error) })
comun.chorrear(() => {
  comun.iniciarMenu('mnuStreamings')
})
buscador.iniciar()

articulus(`${comun.urlBaseApi}/apis/articulus/v1/blogs/streamings`, 'es').then(blog => {
  if (blog.descripcion) {
    document.querySelector('header.descripcion .intro').innerHTML = blog.descripcion
    document.querySelector('header.descripcion').classList.remove('oculto')
  }
}).catch(error => { console.log(error) })

let url = `${comun.urlBaseApi}/apis/articulus/v1/blogs/streamings/articulos/?orden=crono&ordenDir=desc&pag=1&porPag=12`
listarStreamings(url, document.querySelector('.plantilla.streaming'), document.querySelector('.streamings'))

function listarStreamings (urlApi, plantilla, contenedor) {
  articulus(urlApi, 'es').then(artis => {
    mostrarArticulos(artis)
    mostrarPresentaciones()
  }).catch(error => { console.log(error) })
  //
  function mostrarArticulos (artis) {
    if (artis.articulos.length > 0) {
      const estiloBtnExtra = {
        claro: 'color-dos',
        oscuro: 'color-uno',
        borde: 'color-uno-borde'
      }
      artis.articulos.forEach(arti => {
        const articulo = plantilla.cloneNode(true) // Clona plantilla
        articulo.dataset.tituloUrl = arti.tituloUrl
        articulo.querySelector('.subtitulo').textContent = arti.copete
        articulo.querySelector('.imagen img').src = comun.urlBaseApi + arti.imgPrincipal
        articulo.querySelector('.imagen img').srcset = comun.obtenerSrcset(comun.urlBaseApi + arti.imgPrincipal)
        articulo.querySelector('.imagen img').alt = arti.titulo
        try {
          // Cambia comillas dobles por simples dentro de etiquetas html. Convierte, por ejemplo, <a href="#"> en <a href='#'>
          const etiquetasHtml = arti.entradilla.matchAll(/<[^<]*>/g)
          let etiquetaNueva
          for (const etiqueta of etiquetasHtml) {
            etiquetaNueva = etiqueta[0].replace(/\"/g, "'") // Cambia comillas
            arti.entradilla = arti.entradilla.replace(etiqueta[0], etiquetaNueva) // Reemplaza etiqueta en el contenido
          }
          //
          let datosEnIntro = JSON.parse(arti.entradilla)
          if (datosEnIntro.botonesExtra && Array.isArray(datosEnIntro.botonesExtra)) {
            let clonBoton
            datosEnIntro.botonesExtra.forEach(boton => {
              clonBoton = articulo.querySelector('.botonesExtra > .boton-enlazado').cloneNode(true)
              clonBoton.classList.add(estiloBtnExtra[boton.estilo])
              clonBoton.querySelector('.texto').textContent = boton.texto
              clonBoton.querySelector('img').src = boton.icono
              clonBoton.href = boton.url
              articulo.querySelector('.botonesExtra > .lista-botones').appendChild(clonBoton)
              clonBoton.classList.remove('plantilla')
            })
          }
        } catch (e) {
          console.error(e)
        }
        const enlaces = articulo.querySelectorAll('.enlace')
        for (const enlace of enlaces) {
          enlace.href = `/streamings/${arti.tituloUrl}`
        }
        contenedor.appendChild(articulo) // Agrega plantilla al contenedor
        articulo.classList.remove('plantilla') // y la hace visible
      })
    }
  }

  function mostrarPresentaciones () {
    let streamings = document.querySelectorAll('.streamings > .streaming')
    for (const streaming of streamings) {
      url = `${comun.urlBaseApi}/apis/articulus/v1/blogs/streamings/articulos/${streaming.dataset.tituloUrl}/presentaciones`
      articulus(url, 'es').then(presentaciones => {
        let clonProxFuncion, oFecha, aAmd, aHms
        let oAhora = new Date()
        presentaciones.forEach(presenta => {
          aAmd = presenta.fechaHora.substr(0, 10).split("-") // Año mes día
          aHms = presenta.fechaHora.substr(11).split(":") // Hora minutos segundos
          oFecha = new Date(aAmd[0], (parseInt(aAmd[1], 10) - 1), aAmd[2], aHms[0], aHms[1], aHms[2]);
          if (oFecha.getTime() >= oAhora.getTime()) { // Próxima función
            clonProxFuncion = document.querySelector('.prox-funcion.plantilla').cloneNode(true)
            clonProxFuncion.querySelector('.fecha').textContent = getFechaMesCorto(`${aAmd[0]}-${aAmd[1]}-${aAmd[2]}`, 'es')
            clonProxFuncion.querySelector('.ciudad').textContent = presenta.ciudad
            clonProxFuncion.href = presenta.linkTickets
            if (presenta.vendido) {
              clonProxFuncion.querySelector('.estrella').classList.add('oculto')
              clonProxFuncion.querySelector('.triste').classList.remove('oculto')
              clonProxFuncion.classList.remove('color-uno')
              clonProxFuncion.classList.add('color-tres')
              clonProxFuncion.querySelector('.ciudad').innerHTML += ' (AGOTADO)'
            }
            streaming.querySelector('.funciones').insertBefore(clonProxFuncion, streaming.querySelector('.funciones').firstChild)
            clonProxFuncion.classList.remove('plantilla')
          }
        })
      }).catch(error => { console.error(error) })
    }
  }
}
